<template>
  <div v-if="time">
    <div v-if="showType==='hour'" class="count-down-box">
      仅剩
      <div class="count-down-time">{{hour}}</div>
      :
      <div class="count-down-time">{{minutes}}</div>
      :
      <div class="count-down-time">{{seconds}}</div>
    </div>
    <div v-else class="count-down-box">
        仅剩
        <div class="count-down-time">{{day}}</div>
        天
        <div class="count-down-time">{{hour}}</div>
        小时
    </div>
  </div>
</template>
 
<script>
   export default{
     data() {
       return {
         time: '',
         flag: false,
         delay: 1000,
         timer: null,
         showType: '', // 展示样式不同
         day: '',
         hour: '',
         minutes: '',
         seconds: '',
       };
     },
     props: {
       endTime: {
         type: String,
       },
       isSupportEqual: {
         type: Boolean,
         default: false,
       },
     },
     mounted() {
       if (this.endTime) {
         this.timeDown();
         // 处理下 小于24小时的才需要倒计时， 大于24小时的一小时刷一次就行
         setInterval(() => {
           this.timeDown();
         }, this.delay);
       }
     },
     destroyed() {
       clearInterval(this.timer);
     },
     methods: {
       timeDown() {
         let formatDate = '';
         if (this.endTime) {
           formatDate = this.endTime.replace(/-/g, '/');
         }
         const endTime = new Date(`${formatDate} 23:59:59 GMT+8`);
         const nowTime = new Date();
         const leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000, 0);
         const d = parseInt(leftTime / (24 * 60 * 60), 0);
         const h = this.formatTime(parseInt(leftTime / (60 * 60) % 24, 0));
         const m = this.formatTime(parseInt(leftTime / 60 % 60, 0));
         const s = this.formatTime(parseInt(leftTime % 60, 0));
         if (leftTime <= 0) {
           this.flag = true;
           //  this.$emit('time-end');
           this.time = '';
         }

         const flag = this.isSupportEqual ? d >= 1 : d > 1;
         if (flag) {
           const hour = parseInt(leftTime / (60 * 60) % 24, 0);
           this.time = `${d}天${hour}小时`;
           this.delay = 60 * 60 * 1000;
           this.showType = 'day';
           this.day = this.formatTime(d);
           this.hour = h;
         } else {
           this.time = `${h}:${m}:${s}`;
           this.delay = 1000;
           this.showType = 'hour';
           this.hour = h;
           this.minutes = m;
           this.seconds = s;
         }
       },
       formatTime(time) {
         return time > 9 ? time : `0${time}`;
       },
     },
   };
</script>
<style lang="less" scoped>
.count-down-box {
  margin-left: 20px;
  color: #ff8033;
  display: flex;
  align-items: center;
  font-size: 14px;
  .count-down-time {
    width: 16px;
    height: 14px;
    background: rgba(255,128,51,0.75);
    border-radius: 1px;
    font-size: 12px;
    color: #fff;
    margin: 0 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/product/product-info/components/count-down.vue